var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#9BAEBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4446 27.7574C33.4446 31.3356 31.336 33.4441 27.7579 33.4441H19.9717C16.3844 33.4441 14.2759 31.3356 14.2759 27.7574V19.9621C14.2759 16.3839 15.5903 14.2754 19.1685 14.2754H21.1675C21.8858 14.2754 22.5621 14.6136 22.9931 15.1882L23.9059 16.4022C24.3378 16.9757 25.0135 17.3136 25.7315 17.315H28.5611C32.1484 17.315 33.472 19.1406 33.472 22.7918L33.4446 27.7574Z",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9743 28.55C32.9743 31.35 30.9971 33 27.6419 33H20.3409C16.9772 33 15 31.35 15 28.55V22.45C15 19.65 16.2325 18 19.5877 18H21.4622C22.1357 18 22.7699 18.2646 23.174 18.7143L24.03 19.6643C24.435 20.1131 25.0686 20.3775 25.7418 20.3786H28.3951C31.7589 20.3786 33 21.8071 33 24.6643L32.9743 28.55Z",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.059 26.4886H28.6524",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileUpload);
export default __webpack_public_path__ + "static/media/IconFileUpload.f2e6642f.svg";
export { ForwardRef as ReactComponent };